export default {
    title: "Súbory cookies",
    settingsTitle: "Nastavenia cookies",
    settingsLabel: "Nastaviť cookies",
    acceptLabel: "Akceptovať",
    saveLabel:"Uložiť",
    cancelLabel:"Zrušiť",
    message: 'Prezeraním tejto stránky súhlasíte s použitím COOKIES.',
    essentail: {
        category: 'Potrebné cookies pre správny chod stránky',
        name: 'Nevyhnutné cookies pre správny chod stránky',
        description:'Cookies sú súbory s malým množstvom údajov, ktoré môžu obsahovať anonymný jedinečný identifikátor. Cookies sa odosielajú do vášho prehliadača z webových stránok a ukladajú sa na pevný disk vášho počítača. <br/>        Webové stránky JSON Formatter ich konkrétne používajú na zlepšenie používateľských skúseností zapamätaním si predvolieb. Môžete svojmu prehliadaču dať pokyn, aby odmietol všetky súbory cookie alebo aby uviedol, kedy sa súbor cookie odosiela.',
    }
}
